import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  x: "1.432",
  y: ".557",
  fill: "#D1FADF",
  rx: "12",
  transform: "rotate(2 1.432 .557)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2AAEA3",
  "fill-rule": "evenodd",
  d: "m18.26 8.54-7.397 6.655L9.035 13.1c-.338-.342-.887-.381-1.297-.115a.917.917 0 0 0-.302 1.2l2.12 3.736c.209.348.581.57 1.011.586.41.014.807-.182 1.039-.514.376-.457 7.527-8.403 7.527-8.403.932-.888-.13-1.735-.873-1.06z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }